import { render, staticRenderFns } from "./WsExamGroupsParticipantsList.vue?vue&type=template&id=de33cc7a&scoped=true"
import script from "./WsExamGroupsParticipantsList.vue?vue&type=script&lang=js"
export * from "./WsExamGroupsParticipantsList.vue?vue&type=script&lang=js"
import style0 from "./WsExamGroupsParticipantsList.vue?vue&type=style&index=0&id=de33cc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de33cc7a",
  null
  
)

export default component.exports